import { render, staticRenderFns } from "./UiSelectbox.vue?vue&type=template&id=f2d6c33e"
import script from "./UiSelectbox.vue?vue&type=script&lang=js"
export * from "./UiSelectbox.vue?vue&type=script&lang=js"
import style0 from "./UiSelectbox.vue?vue&type=style&index=0&id=f2d6c33e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports